import getImmutableEntryId from '../utils/getImmutableEntryId';
import { lazyLogSigsDatapoint, logUsage } from 'owa-analytics';
import ContentHandler from 'owa-controls-content-handler/lib/schema/ContentHandler';
import { userMailInteractionAction } from 'owa-mail-actions';
import isYammerEnabled from 'owa-mail-store-actions/lib/utils/isYammerEnabled';
import { getSelectedTableView } from 'owa-mail-list-store';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import { ClientItem } from 'owa-mail-store';

const CLICK_EVENT_NAME = 'click';
const LINK_HANDLER_SELECTOR = 'a';
export const LINK_HANDLER_NAME = 'linkHandler';
const YAMMER_THREAD_ID_REGEXP = new RegExp('threadId=([0-9]+)');

export class LinkHandler implements ContentHandler {
    public readonly cssSelector = LINK_HANDLER_SELECTOR;
    public readonly keywords = null;

    private boundElements: {
        element: HTMLElement;
        handler: (clickEvent: MouseEvent) => void;
    }[];
    private item: ClientItem;

    constructor(item: ClientItem) {
        this.boundElements = [];
        this.item = item;
    }

    public readonly handler = (element: HTMLElement, keyword?: string) => {
        const clickHandler = (item: ClientItem) => (evt: MouseEvent) => {
            const tableView = getSelectedTableView();
            const selectedRowKeys = tableView ? [...tableView.selectedRowKeys.keys()] : [];
            if (selectedRowKeys.length === 1) {
                const instrumentationContext = getInstrumentationContextsFromTableView(
                    selectedRowKeys,
                    tableView
                )[0];

                userMailInteractionAction('LinkClicked', [instrumentationContext]);
            }

            if (item) {
                getImmutableEntryId(item).then(immutableEntryId => {
                    if (immutableEntryId) {
                        logUsage('RPMessageBodyLinkClicked', [], {
                            cosmosOnlyData: immutableEntryId,
                        });
                        lazyLogSigsDatapoint.importAndExecute('LinkClicked', {
                            itemId: immutableEntryId,
                        });
                    }
                });

                this.tryLogYammerLinkClicked(item, evt);
            }
        };

        element.addEventListener(CLICK_EVENT_NAME, clickHandler(this.item));
        this.boundElements.push({ element: element, handler: clickHandler(this.item) });
    };

    public readonly undoHandler = (elements: HTMLElement[]) => {
        this.boundElements.forEach(boundElement =>
            boundElement.element.removeEventListener(CLICK_EVENT_NAME, boundElement.handler)
        );
        this.boundElements = [];
    };

    private tryLogYammerLinkClicked(item: ClientItem, evt: MouseEvent) {
        if (item.YammerNotification) {
            let yammerThreadId = item.YammerThreadId;

            // YammerThreadId will not be set if the rp-yammer flight is disabled
            if (!yammerThreadId) {
                const threadIdMatches = item.YammerNotification.match(YAMMER_THREAD_ID_REGEXP);

                yammerThreadId =
                    threadIdMatches && threadIdMatches.length == 2 ? threadIdMatches[1] : null;
            }

            const anchorElement = evt.srcElement as HTMLAnchorElement;
            if (
                yammerThreadId &&
                anchorElement &&
                anchorElement.href.indexOf(yammerThreadId) > -1
            ) {
                logUsage('YammerViewConversationClicked', {
                    yammerEnabled: isYammerEnabled(),
                });
            }
        }
    }
}
